import React from "react";
import "./styles/style.css"; // Global CSS

// Components
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Services from "./components/Services";
import Products from "./components/Products";
import Portfolio from "./components/Portfolio";
import Exper from "./components/Exper";  // ✅ Exper section
import Team from "./components/Team";
import Process from "./components/process";
import Contacts  from "./components/Contacts";
import Testimonials from "./components/Testimonials";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

function App() {
  return (
    <>
      <Header />
      <Hero />
      <About />
      <Services />
      <Products />
      <Portfolio />
      <Exper />
      <Team />
      <Process/>
      <Testimonials />
      <Contacts />
      <Contact />
      <Footer />
    </>
  );
}

export default App;
